import React, { memo } from 'react'
import { Text } from 'common-components'
import * as Styled from './styled'

interface ISectionHeaderProps {
  label: string
}

const SectionHeader: React.FC<ISectionHeaderProps> = ({ label }) => (
  <Styled.SectionHeaderWrapper>
    <Text type="h3" color="secondaryDark" letterSpacing="0.6px">
      {label}
    </Text>
  </Styled.SectionHeaderWrapper>
)

export default memo(SectionHeader)
